import { 
	// USER
	UPDATE_USER,
	DELETE_USER,
	// DASHBOARD
	UPDATE_BOOKINGS,
	ADD_RESERVATION,
	ADD_LOCATION,
	ADD_UNIT,
	ADD_PROTECTION,
	// PAYMENT
	RESET_PAYMENT,
	SET_PAYMENT_PAGE_INDEX,
	ADD_PAYMENT_PAGE,
	SET_PAYMENT_LOCATION,
	SET_PAYMENT_RESERVATION,
	SET_PAYMENT_MOVEIN,
	SET_PAYMENT_DISCOUNT,
	SET_PAYMENT_DISCOUNT_ID,
	SET_PAYMENT_DIRECT_BOOKING,
	SET_PAYMENT_UNIT_SELECTION,
	ADD_PAYMENT_UNIT_INFO,
	SET_PAYMENT_CARD_INFO,
	SET_PAYMENT_ENCRYPTED_CARD_INFO,
	SET_PAYMENT_SIZE_SUGGESTIONS,
	SET_PAYMENT_AMENITY_SUGGESTIONS,
	ADD_PAYMENT_RETAIL,
	CLEAR_PAYMENT_RETAIL,
	SET_PAYMENT_RETAIL,
	ADD_PAYMENT_INSURANCE,
	CLEAR_PAYMENT_INSURANCE,
	SET_PAYMENT_INSURANCE,
	// META
	SET_POPUP_RECORD,
	SET_ADMIN_LOCATION
} from './actionTypes'

import { combineReducers	} from 'redux'

const bookingsReservationsInitialState = {
	bookings: [],
	locations: {},
	reservations: {},
	units: {},
	protections: {}
}

const userReducer = (state = {}, action) => {
	switch (action.type) {
		case UPDATE_USER:
			return {
				...state,
				...action.payload
			}
		case DELETE_USER:
			return {}
		default:
			return state
	}
}

const bookingsReservationsReducer = (state = bookingsReservationsInitialState, action) => {
	switch (action.type) {
		case DELETE_USER:
			return bookingsReservationsInitialState
		case UPDATE_BOOKINGS:
			return {
				...state,
				bookings: action.payload
			}
		case ADD_LOCATION:
			return {
				...state,
				locations: {
					...state.locations,
					[action.payload._id]: action.payload
				}
			}
		case ADD_RESERVATION:
			return {
				...state,
				reservations: {
					...state.reservations,
					[action.payload._id]: action.payload
				}
			}
		case ADD_UNIT:
			return {
				...state,
				units: {
					...state.units,
					[action.payload._id]: action.payload
				}
			}
		case ADD_PROTECTION:
			return {
				...state,
				protections: {
					...state.protections,
					[action.payload._id]: action.payload
				}
			}
		default:
			return state
	}
}

const paymentIntitialState = {
	navigation: {
		pages: ['card'],
		currentPageIndex: 0
	},
	location: null,
	reservation: null,
	moveIn: null,
	discount: null,
	discountId: null,
	directBooking: false,
	unitSelections: {
		original: null,
		size: null,
		amenity: null,
		amenityType: 'base'
	},
	cardInfo: {
		addresses: {
			home: {},
			billing: {}
		},
		autoPay: true,
		billingSameAsHome: true,
		isBusiness: false,
		businessName: ''
	},
	suggestions: {
		size: [],
		amenity: []
	},
	units: {},
	insurance: {
		options: [],
		selection: null
	},
	retail: {
		options: [],
		selections: {}
	}
}

const paymentReducer = (state = paymentIntitialState, action) => {
	switch (action.type) {
		case RESET_PAYMENT:
			return paymentIntitialState
		case SET_PAYMENT_PAGE_INDEX:
			return {
				...state,
				navigation: {
					pages: state.navigation.pages,
					currentPageIndex: action.payload
				}
			}
		case ADD_PAYMENT_PAGE:
			const currentPages = state.navigation.pages
			const newPagesArray = currentPages.includes(action.payload) ? currentPages : [...currentPages, action.payload]
			return {
				...state,
				navigation: {
					pages: newPagesArray,
					currentPageIndex: state.navigation.currentPageIndex + 1
				}
			}
		case SET_PAYMENT_LOCATION:
			return {
				...state,
				location: action.payload
			}
		case SET_PAYMENT_RESERVATION:
			return {
				...state,
				reservation: action.payload
			}
		case SET_PAYMENT_MOVEIN:
			return {
				...state,
				moveIn: action.payload
			}
		case SET_PAYMENT_DISCOUNT:
			return {
				...state,
				discount: action.payload
			}
		case SET_PAYMENT_DISCOUNT_ID:
			return {
				...state,
				discountId: action.payload
			}
		case SET_PAYMENT_DIRECT_BOOKING: 
			return {
				...state,
				directBooking: action.payload
			}
		case SET_PAYMENT_UNIT_SELECTION:
			return {
				...state,
				unitSelections: {
					...state.unitSelections,
					[action.payload.type]: action.payload.unit
				}
			}
		case ADD_PAYMENT_UNIT_INFO:
			return {
				...state,
				units: {
					...state.units,
					...(action.payload && {[action.payload._id]: action.payload})
				}
			}
		case SET_PAYMENT_CARD_INFO: 
			return {
				...state,
				cardInfo: action.payload
			}
		case SET_PAYMENT_ENCRYPTED_CARD_INFO:
			return {
				...state,
				cardInfo: {
					...state.cardInfo,
					encryptedPaymentInfo: action.payload
				}
			}
		case SET_PAYMENT_SIZE_SUGGESTIONS:
			return {
				...state,
				suggestions: {
					...state.suggestions,
					size: action.payload
				}
			}
		case SET_PAYMENT_AMENITY_SUGGESTIONS:
			return {
				...state,
				suggestions: {
					...state.suggestions,
					amenity: action.payload
				}
			}
		case ADD_PAYMENT_RETAIL:
			return {
				...state,
				retail: {
					...state.retail,
					options: [
						...state.retail.options,
						action.payload
					]
				}
			}
		case CLEAR_PAYMENT_RETAIL:
			return {
				...state,
				retail: {
					...state.retail,
					options: []
				}
			}
		case SET_PAYMENT_RETAIL:
			if (action.payload.quantity === 0) {
				const { [action.payload.retail]: value, ...rest } = state.retail.selections
				return {
					...state,
					retail: {
						...state.retail,
						selections: {
							...rest
						}
					}
				}
			}
			return {
				...state,
				retail: {
					...state.retail,
					selections: {
						...state.retail.selections,
						[action.payload.retail]: action.payload.quantity
					}
				}
			}
		case ADD_PAYMENT_INSURANCE:
			return {
				...state,
				insurance: {
					...state.insurance,
					options: [
						...state.insurance.options,
						action.payload
					]
				}
			}
		case CLEAR_PAYMENT_INSURANCE:
			return {
				...state,
				insurance: {
					...state.insurance,
					options: []
				}
			}
		case SET_PAYMENT_INSURANCE:
			return {
				...state,
				insurance: {
					...state.insurance,
					selection: action.payload
				}
			}
		default:
			return state
	}
}

const metaIntitialState = {
	popupRecords: {
		cookiesConsent: false,
		onboardingCardSelection: false,
		discountSignUp: false,
		discountColorado: false
	},
	adminLocation: null
}

const metaReducer = (state = metaIntitialState, action) => {
	switch (action.type) {
		case SET_POPUP_RECORD:
			return {
				...state,
				popupRecords: {
					...state.popupRecords,
					[action.payload.id]: action.payload.to
				}
			}
		case SET_ADMIN_LOCATION:
			return {
				...state,
				adminLocation: action.payload
			}
		default:
			return state
	}
}

const rootReducer = combineReducers({
	user: userReducer,
	bookingsReservations: bookingsReservationsReducer,
	payment: paymentReducer,
	meta: metaReducer
})

export default rootReducer
